import { useEffect, useState } from "react";
import { Paperclip, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function CallFiles({ token, by, dark = false, testid = "call-files" }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    try {
      const r = await fetch(`${BACKEND}/api/public/call/${token}/files`);
      if (r.ok) setFiles(await r.json());
    } catch { /* ignore */ }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await fetch(`${BACKEND}/api/public/call/${token}/upload?by=${encodeURIComponent(by || "Guest")}`, { method: "POST", body: fd });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Upload failed — try again");
      toast.success("Shared with everyone on the call");
      load();
    } catch (err) { toast.error(err.message); }
    setUploading(false);
    e.target.value = "";
  };

  const box = dark ? "border-slate-700 bg-[#0F141B] text-slate-300" : "border-slate-200 bg-white text-slate-700";
  return (
    <div className={`rounded-2xl border p-4 ${box}`} data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <p className={`text-xs font-bold uppercase tracking-wider ${dark ? "text-slate-400" : "text-slate-500"}`}>Shared files</p>
      </div>
      {files.length === 0 && <p className={`text-xs ${dark ? "text-slate-500" : "text-slate-400"}`} data-testid={`${testid}-empty`}>Nothing shared yet.</p>}
      <div className="space-y-1.5">
        {files.map((f, i) => (
          <a key={i} href={f.url} target="_blank" rel="noreferrer" data-testid={`${testid}-file-${i}`}
            className={`flex items-center gap-2 text-xs font-semibold rounded-lg px-2.5 py-2 ${dark ? "bg-white/5 hover:bg-white/10 text-slate-200" : "bg-slate-50 hover:bg-slate-100 text-[#005EB8]"}`}>
            <Paperclip className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{f.name}</span>
            <span className={`ml-auto shrink-0 ${dark ? "text-slate-500" : "text-slate-400"}`}>{f.by}</span>
          </a>
        ))}
      </div>
      <label className={`mt-3 h-10 rounded-lg border border-dashed text-xs font-bold inline-flex items-center justify-center gap-1.5 w-full cursor-pointer transition-colors ${dark ? "border-slate-600 text-slate-300 hover:border-slate-400" : "border-slate-300 text-[#005EB8] hover:border-[#005EB8]"}`} data-testid={`${testid}-upload`}>
        {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Paperclip className="h-3.5 w-3.5" />}
        {uploading ? "Sharing…" : "Share a file"}
        <input type="file" className="hidden" onChange={upload} disabled={uploading} />
      </label>
    </div>
  );
}
